import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import './SupportTeamLogin.css';

function SupportTeamLogin() {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/auth/support-login', credentials);
      const { user, token, refreshToken } = response.data.data;

      // Store tokens using same keys the axios interceptor reads
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('support_user', JSON.stringify(user));

      // Full reload so AuthContext picks up the new token via checkAuth()
      window.location.href = '/support-team/dashboard';
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
      setLoading(false);
    }
  };

  return (
    <div className="support-login">
      <div className="support-login-container">
        <div className="support-login-header">
          <div className="support-logo">
            🎧
          </div>
          <h1>Support Team Portal</h1>
          <p>Customer Support Ticket Management</p>
        </div>

        <form className="support-login-form" onSubmit={handleSubmit}>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              placeholder="support@foodwinc.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="support-login-btn"
            disabled={loading}
          >
            {loading ? 'Signing In...' : '🔐 Sign In to Support Portal'}
          </button>
        </form>

        <div className="support-login-footer">
          <p>Authorized Support Team Personnel Only</p>
          <p className="help-text">
            For assistance, contact your system administrator
          </p>
        </div>
      </div>
    </div>
  );
}

export default SupportTeamLogin;
